export default __webpack_public_path__ + "static/media/logoMb.c716d316.png";